import AdminPage from "../../../core/admin/adminPage";
import AdminsList from "./adminsList";
import AdvertisersList from "./advertisersList";
import CreateUser from "./createUser";
import FindUser from "./findUser";

export default function AdminUsers() {


    return (
        <AdminPage title="Usuários" description="Crie contas já configuradas, ou pesquise um usuário por e-mail para validar contatos manualmente e alterar papéis de acesso.">
            <FindUser />
            <CreateUser />
            <div className="grid grid-cols-1 gap-6">
                <AdvertisersList />
                <AdminsList />
            </div>
        </AdminPage>
    )
}
